webpackJsonp([110393827018102],{

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _navigation = __webpack_require__(13);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _footer = __webpack_require__(12);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _GlobalFunctions = __webpack_require__(24);
	
	var _seo = __webpack_require__(38);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	var _registerNow = __webpack_require__(142);
	
	var _registerNow2 = _interopRequireDefault(_registerNow);
	
	var _cover = __webpack_require__(19);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RenderItems = function (_React$Component) {
		(0, _inherits3.default)(RenderItems, _React$Component);
	
		function RenderItems(props) {
			(0, _classCallCheck3.default)(this, RenderItems);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
			_this.changePolicy = _this.changePolicy.bind(_this);
	
			_this.state = {
				privacyId: 1,
				privacyCurrentId: 1,
				privacyText: '',
				privacyVersion: '',
				privacyDateVersion: '',
				privacyEffectiveDate: '',
				privacyPrevious: [],
				privacyLoaded: false
			};
			return _this;
		}
	
		RenderItems.prototype.formatDate = function formatDate(iso) {
			var date = new Date(iso),
			    year = date.getFullYear(),
			    month = date.getMonth() + 1,
			    dt = date.getDate(),
			    newdata = (month < 10 ? '0' + month : month) + '/' + (dt < 10 ? '0' + dt : dt) + '/' + year;
			return newdata;
		};
	
		RenderItems.prototype.changePolicy = function changePolicy(e) {
			var self = this;
			self.setState({ privacyLoaded: false });
			(0, _GlobalFunctions.getJSON_and_pass)('GET', '/contractor_profile/api/policies/' + e, null, function (data) {
				if (typeof data === 'string') data = JSON.parse(data);
				self.setState({ privacyText: data.data.specification });
				self.setState({ privacyEffectiveDate: data.data.enabled_date });
				self.setState({ privacyCurrentId: e });
				self.setState({ privacyLoaded: true });
			}, function (status) {});
		};
	
		RenderItems.prototype.componentDidMount = function componentDidMount() {
			var self = this;
			(0, _GlobalFunctions.getJSON_and_pass)('GET', '/contractor_profile/api/policies', null, function (data) {
				if (typeof data === 'string') data = JSON.parse(data);
				self.setState({ privacyId: data.data[0].id });
				self.setState({ privacyCurrentId: data.data[0].id });
				self.setState({ privacyText: data.data[0].specification });
				self.setState({ privacyVersion: data.data[0].version });
				self.setState({ privacyDateVersion: data.data[0].enabled_date });
				self.setState({ privacyEffectiveDate: data.data[0].enabled_date });
				if (data.data[0].previous) self.setState({ privacyPrevious: data.data[0].previous });
				self.setState({ privacyLoaded: true });
			}, function (status) {});
		};
	
		RenderItems.prototype.renderElement = function renderElement() {
			var self = this;
			if (self.state.privacyPrevious.length > 0) return self.state.privacyPrevious.map(function (index) {
				if (self.state.privacyCurrentId !== index.id) {
					return _react2.default.createElement(
						"li",
						{ key: index.id },
						"Click here for version ",
						_react2.default.createElement(
							"a",
							{ href: "#privacy-" + index.id, onClick: function onClick(e) {
									e.preventDefault();self.changePolicy(index.id);
								} },
							index.version
						),
						" (",
						self.formatDate(index.enabled_date),
						")"
					);
				} else {
					return _react2.default.createElement(
						"li",
						{ key: index.id },
						"This is version ",
						index.version,
						" (",
						self.formatDate(index.enabled_date),
						")"
					);
				}
			});
			return null;
		};
	
		RenderItems.prototype.render = function render() {
			var self = this;
			if (this.state.privacyLoaded) {
				return _react2.default.createElement(
					"div",
					{ className: "privacy-content" },
					_react2.default.createElement(
						"div",
						{ className: "privacy-date" },
						"Effective Date: ",
						self.formatDate(self.state.privacyEffectiveDate)
					),
					_react2.default.createElement("div", { className: "privacy-text", dangerouslySetInnerHTML: { __html: this.state.privacyText } }),
					_react2.default.createElement(
						"h4",
						null,
						"Previous Versions"
					),
					_react2.default.createElement(
						"ul",
						{ className: "privacy-versions" },
						self.state.privacyCurrentId !== self.state.privacyId ? _react2.default.createElement(
							"li",
							null,
							"Click here for version ",
							_react2.default.createElement(
								"a",
								{ href: "#privacy-" + self.state.privacyId, onClick: function onClick(e) {
										e.preventDefault();self.changePolicy(self.state.privacyId);
									} },
								self.state.privacyVersion
							),
							" (",
							self.formatDate(self.state.privacyDateVersion),
							")"
						) : _react2.default.createElement(
							"li",
							null,
							"This is version ",
							self.state.privacyVersion,
							" (",
							self.formatDate(self.state.privacyDateVersion),
							")"
						),
						self.renderElement()
					)
				);
			} else {
				return _react2.default.createElement("div", { className: "form-loader" });
			}
		};
	
		return RenderItems;
	}(_react2.default.Component);
	
	var Seo = function (_React$Component2) {
		(0, _inherits3.default)(Seo, _React$Component2);
	
		function Seo() {
			(0, _classCallCheck3.default)(this, Seo);
			return (0, _possibleConstructorReturn3.default)(this, _React$Component2.apply(this, arguments));
		}
	
		Seo.prototype.pageClick = function pageClick(e) {
			document.getElementsByTagName('body')[0].className = '';
		};
	
		Seo.prototype.componentDidMount = function componentDidMount() {
			var mask = document.getElementById('mask'),
			    seoText = document.getElementById('seo-text');
			mask.addEventListener('touchstart', this.pageClick, false);
		};
	
		Seo.prototype.render = function render() {
			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(_reactHelmet2.default, {
					title: "Privacy Policy | UvoCorp.com",
					meta: [{ name: "description", content: "Privacy Policy" }, { name: "robots", content: "noindex, follow" }, { property: 'og:title', content: "Privacy Policy | UvoCorp.com" }, { property: 'og:description', content: "Privacy Policy" }, { property: 'og:site_name', content: "UvoCorp.com" }, { property: 'og:type', content: "website" }, { property: 'og:image', content: _cover2.default }],
					link: [{ rel: 'canonical', href: "https://www.uvocorp.com/privacy_policy.html" }] }),
				_react2.default.createElement(
					"div",
					{ className: "header", id: "header" },
					_react2.default.createElement(_navigation2.default, null)
				),
				_react2.default.createElement(
					"div",
					{ className: "wrapper" },
					_react2.default.createElement(
						"div",
						{ className: "inner-header" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h1",
								null,
								"Privacy Policy"
							),
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: "/register_email.html" },
								"Register now"
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-white hiring seo" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "row seo-row" },
								_react2.default.createElement(
									"div",
									{ className: "col-md-4 seo-img-container" },
									_react2.default.createElement(
										"div",
										{ className: "seo-img" },
										_react2.default.createElement("img", { src: _seo2.default, alt: "Seo Image" })
									)
								),
								_react2.default.createElement(
									"div",
									{ className: "col-md-8" },
									_react2.default.createElement(
										"div",
										{ className: "seo-text" },
										_react2.default.createElement(RenderItems, null)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-registration" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-image" },
								_react2.default.createElement(
									"div",
									{ className: "img inner-registration-img" },
									_react2.default.createElement("img", { src: _registerNow2.default, alt: "Start registration" })
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-text" },
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-title" },
									"Register now ",
									_react2.default.createElement("br", null),
									"to start earning!"
								),
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-button" },
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: "/register_email.html" },
										"Start registration"
									)
								)
							)
						)
					),
					_react2.default.createElement(_footer2.default, null)
				),
				_react2.default.createElement("div", { id: "mask", className: "c-mask" })
			);
		};
	
		return Seo;
	}(_react2.default.Component);
	
	exports.default = Seo;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-policy-html-js-5a8cb8739568f45e616b.js